import component from './TitleEditor.vue'
export default component
